// removed by extract-text-webpack-plugin
module.exports = {"stock-chart-details":"finance_stock-chart-details_x","chart-col":"finance_stock-chart-details_chart-col","stock-chart":"finance_stock-chart-details_stock-chart","details-col":"finance_stock-chart-details_details-col","positive":"finance_stock-chart-details_positive","negative":"finance_stock-chart-details_negative","highlight":"finance_stock-chart-details_highlight","detail":"finance_stock-chart-details_detail","row":"finance_stock-chart-details_row","label":"finance_stock-chart-details_label"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/stock-chart-details/style.less
// module id = 1065
// module chunks = 0